module.exports = __webpack_public_path__ + "images/emoji/jack_o_lantern.a19bf5740b75c97b6be9.png";